<template>
  <div class="card mt-3">
    <div class="border-bottom">
      <div
        class="bg-white p-2 pt-3 pl-4  w-100 d-flex justify-content-between"
        >
        <h4>{{ product.name }}</h4>
        <div>
          <button class="btn btn-sm btn-dark mr-2" @click="printLabel(product.id)"><i class="fa fa-barcode"></i> Print Label</button>
          <button class="btn btn-sm btn-dark" @click="adjust"><i class="fa fa-edit"></i> Adjust</button>
          
        </div>
      </div>
    </div>
    <div id="product" class="">
      <div class="col-12">
        <div class="my-0 p-4">
          <div class="row">
            <div class="col-md-4">
              <table class="table table-sm table-borderless border-right">
                <tr><td><strong>LM SKU</strong></td><td>LM-{{ product.id }}</td></tr>
                <tr><td><strong>Client</strong></td><td>{{ product.customer_sku }}</td></tr>
                <tr><td><strong>Client SKU</strong></td><td>{{ product.customer_sku }}</td></tr>
                <tr><td><strong>UPC</strong></td><td>{{ product.upc }}</td></tr>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table table-sm border-right table-borderless">
                <tr><td><strong>Length (in.)</strong></td><td>{{ product.length }}</td></tr>
                <tr><td><strong>Width (in.)</strong></td><td>{{ product.width }}</td></tr>
                <tr><td><strong>Height (in.)</strong></td><td>{{ product.height }}</td></tr>
                <tr><td><strong>Weight (lbs.)</strong></td><td>{{ product.weight }}</td></tr>
              </table>                
            </div>
            <div class="col-md-4">
              <div class="text-right">
              <table class="table table-sm table-borderless border-right">
                <tr><td><strong>Available</strong></td><td>{{ product.available }}</td></tr>
                <tr><td><strong>On Hand</strong></td><td>{{ product.on_hand }}</td></tr>
                <tr><td><strong>Allocated</strong></td><td>{{ product.allocated }}</td></tr>
                <tr><td><strong>Inbound</strong></td><td>{{ product.inbound }}</td></tr>
              </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 p-0">
        <div class="">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item ml-2">
              <a class="nav-link active" id="inv-tab" data-toggle="tab" href="#inv"><i class="fa fa-pallet"></i> Inventory</a>
            </li>
            <li class="nav-item ml-2">
              <a class="nav-link" id="log-tab" data-toggle="tab" href="#log"><i class="fa fa-stream"></i> Transaction Log</a>
            </li>
            <li class="nav-item ml-2">
              <a class="nav-link" id="components-tab" data-toggle="tab" href="#components"><i class="fa fa-cubes"></i> Components</a>
            </li>
          </ul>

          <div class="tab-content bg-white">
            <div class="tab-pane fade show active" id="inv">
              <inventory-tab :product="product"></inventory-tab>
            </div>
            <div class="tab-pane fade" id="log">
              <log-tab :product="product"></log-tab>
            </div>
            <div class="tab-pane fade" id="components">
              <component-tab :product="product"></component-tab>
            </div>
          </div>        
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment'
import JsBarcode from 'jsbarcode'
// import store from '@/stores/products'
import product from '@/libs/product'

import InventoryTab from '@/components/products/InventoryTab.vue'
import LogTab from '@/components/products/LogTab.vue'
import ComponentTab from '@/components/products/ComponentTab.vue'

import printJS from 'print-js'
import api from '@/api'

export default {
  name: 'products',
  components: {
    InventoryTab,
    LogTab,
    ComponentTab,
  },

  data() {
    return {
      product: {
        inventory: [],
        components: [],
        log: [],
      }
    }
  },

  mounted() {
    if (this.$route.params.id && this.$route.params.id > 0 ) {
      product.find(this.$route.params.id).then(res => {
        this.product = res.data.product
        JsBarcode("#barcode", `LM-${this.product.id}`);
      }).then(() => {
        
      })
    }
  },

  methods: {
    calendar(date) {
      return moment(date).calendar()
    },

    printLabel(id) {
      printJS({
        printable: api.baseUrl + '/products/' + id + '/label',
        type: 'pdf',
        showModal: true,
        modalMessage: 'Making Label...'
      })  
    },

    adjust() {
      alert("Not yet, but soon.")
    }
  }
}
</script>

<style scoped>
#barcode {
  border: solid 1px #333;
  border-radius: 5px;
}

#product {
  height: calc(100vh - 150px);
  overflow-y: auto;
}
</style>